import domain from '../domain';

const libReset = domain.event('libReset');

export default libReset;
